import { IconPlus } from '@tabler/icons-react';
import { useState } from 'react';
import { Button, Grid } from '@mantine/core';
import AddCustomFieldModal from '../Modals/AddCustomFieldModal';
import BoostFiltersDescription from './BoostFiltersDescription';
import ProductFeedRule from './ProductFeedRule';

const BoostAndFiltersProductFeedForm = ({ productFeed, customFields, updateRule, addRule }) => {
  const [ruleModalOpen, setRuleModalOpen] = useState(false);

  const ruleItems = productFeed.rules.map((rule, i) => {
    return (
      <div
        key={i}
        data-tour={rule.field === 'price' ? 'priceField' : rule.field === 'categories' ? 'exactCategoryField' : null}
      >
        <ProductFeedRule scope={productFeed.scope} rule={rule} updateRule={(changes) => updateRule(i, changes)} />
        <hr />
      </div>
    );
  });

  const disabledNotification = <small>There are no custom fields in your products and custom rules are disabled</small>;

  return (
    <>
      <BoostFiltersDescription />
      {ruleItems}
      <Grid>
        <Grid.Col span={{ base: 12, sm: 4 }}></Grid.Col>
        <Grid.Col span={{ base: 12, sm: 8 }} data-tour="customRule">
          <Button
            size="sm"
            fullWidth
            variant="default"
            onClick={() => setRuleModalOpen(true)}
            disabled={customFields.product.length === 0}
          >
            <IconPlus size={14} /> Custom Rule
          </Button>
          {customFields.product.length === 0 && disabledNotification}
        </Grid.Col>
      </Grid>
      <AddCustomFieldModal
        availableCustomFields={customFields.product}
        show={ruleModalOpen}
        save={(field, cb) => {
          const rule = {
            mode: 'off',
            type: field.type,
            field: `custom.${field.type}.${field.field}`,
            values: [],
            valueMultipliers: [],
            name: field.name,
          };
          addRule(rule, cb);
          cb();
        }}
        close={() => setRuleModalOpen(false)}
      />
    </>
  );
};

export default BoostAndFiltersProductFeedForm;
